import { normalizeWelcomeDrawerReviewDoc } from "pages/Welcome/welcomeDrawerReviewDoc";

export function timelineItemToDrawerReview(item) {
  if (!item || typeof item !== "object") {
    return null;
  }
  const payload = item.raw_payload || {};
  const detail = item.review_detail || payload.review_detail || {};
  const base =
    item.drawer_review && typeof item.drawer_review === "object"
      ? item.drawer_review
      : {
          text: detail.main_text || payload.text || item.summary || "",
          title: detail.review_type || payload.title || "",
          timestamp: item.occurred_at || detail.submitted_at,
          date_gpid: payload.date_gpid,
          dash_id: payload.dashboard_id,
          dashboard_id: payload.dashboard_id,
          num_rating: detail.rating,
          pivot: payload.pivot,
        };
  return normalizeWelcomeDrawerReviewDoc(base);
}

export function buildTimelineDrawerReviews(items) {
  return (items || [])
    .map((item) => timelineItemToDrawerReview(item))
    .filter(Boolean);
}
